import { API_SERVER_URL } from '../../common/utils/utils';
import { zendoStorage } from '../../hybrid/wrappers';
import { dataSender } from '../../common/utils/router';
import { getWishList } from '../../common/utils/memo';
import { t } from '../../common/components/T';

export const addProductFunction = async (
    e,
    cartData,
    product,
    setCartData,
    setCart,
    setAlertData,
    userToken,
    lang,
    localization,
    setAllowAddProduct,
    profileData
) => {
    const getData = (id) =>
        new Promise((resolve) => {
            dataSender(
                `${API_SERVER_URL}/api/v1/shop/carts/${id}/add-product`,
                'POST',
                {
                    product_id: product.id,
                    quantity: 1
                },
                (response) => {
                    setCartData(response.data?.data);
                    setCart(true);
                    setAllowAddProduct(true);
                },
                (data) => {
                    if (data.message) {
                        resolve({
                            globalErr: { type: 'error', cont: data.message }
                        });
                    } else {
                        resolve(false);
                    }
                    setAllowAddProduct(true);
                },
                userToken,
                lang,
                profileData?.currency?.code || localization?.currency
            );
        });
    if (!cartData.id) {
        let newCartIdRest = await fetch(`${API_SERVER_URL}/api/v1/shop/carts`, {
            method: 'POST',
            headers: {
                ...(userToken ? { Authorization: `Bearer ${userToken}` } : {})
            }
        });

        let newCartId = await newCartIdRest.json();
        window && zendoStorage.set('cart_id', newCartId.data.id);
        return await getData(newCartId.data.id);
    }
    const data = await getData(cartData.id);

    const globalErr = data.globalErr;
    if (globalErr) {
        setAlertData(globalErr);
    } else if (data) {
    }
};
export const wishProductFunction = (
    product,
    isInWishList,
    setWishlist,
    userToken,
    lang,
    localization,
    setAllow,
    setAlertData,
    translation
) =>
    new Promise((resolve) => {
        dataSender(
            `${API_SERVER_URL}/api/v1/shop/wishlist/products/${product.id}`,
            isInWishList ? 'DELETE' : 'POST',
            null,
            (result) => {
                getWishList.cache.clear();
                setWishlist(result.data);
                setAllow(true);
                !isInWishList &&
                    setAlertData({
                        type: 'success',
                        cont: t('store-wishlist-alert-success', 'Товар добавлен в список желаний', '/store', translation)
                    });
                resolve();
            },
            () => {
                getWishList.cache.clear();
                getWishList(userToken, lang, localization.currency).then((res) => setWishlist(res));
                setAllow(true);
                resolve();
            },
            userToken,
            lang,
            localization?.currency
        );
    });
